import React from 'react'
import Payment from '../Payment'


const PaymentPage = () => {
    return (
        <Payment />
    )
}

export default PaymentPage


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/PaymentPage.js